import React from 'react'

/**
 * This function renders the rectangles and the labels of a bar graph
 */
function PieGraphWebReport(props) {

    const radius = 50;
    const pt_cx = 100, pt_cy = 100;
    // Using the Math.PI will return more than 2 digits after the decimal point
    // It is why we use 3.14 instead of Math.PI
    const circumference = 2 * 3.14 * radius;
    const colorData = props.colorData;
    const transform_data = "translate(90,90) scale(1.7)";
    const adapt_pos = 75;
    const hilf_tmp = [-0.5, 1, 0.5];
    let arc_length_hin_pot_risk = [0, 0, 0];
    let piegraph_data = [{labeltxt: '', posX: 0, posY: 0}];
    const data = props.pieChartData;

    if (data !== undefined && data.length !== 0) {

        const num_items_hin_pot_risk = [data.Hinweis, data.Potenzial, data.Risiko];
        const total_items = num_items_hin_pot_risk.reduce((a, b) => a + b, 0);

        // Compute the arc length of each slice (hinweis, risiko, potential).
        arc_length_hin_pot_risk = [];
        for (let value of num_items_hin_pot_risk) {
            arc_length_hin_pot_risk.push((value * circumference) / total_items);
        }

        // Compute the arc angle for each arc of the 3 slices (hinweis, potential, risiko)
        const arc_angle_in_deg_hin_pot_risk = [((circumference) - (arc_length_hin_pot_risk[1] + arc_length_hin_pot_risk[2])),
            (arc_length_hin_pot_risk[1] / 2 + (arc_length_hin_pot_risk[2])), arc_length_hin_pot_risk[2]];

        // Compute and store into a dict the variables needed to compute a pie chart
        piegraph_data = [];
        for (let value = 0; value < num_items_hin_pot_risk.length; value++) {
            const arc_angle_in_rad = arc_angle_in_deg_hin_pot_risk[value] * 360 / circumference;
            const posX = adapt_pos * Math.cos(hilf_tmp[value] * Math.PI * arc_angle_in_rad / 180);
            const posY = adapt_pos * Math.sin(hilf_tmp[value] * Math.PI * arc_angle_in_rad / 180);
            const tmp_dict = {
                labeltxt: num_items_hin_pot_risk[value] === 0 ? '' : num_items_hin_pot_risk[value],
                posX: -100 + posX,
                posY: posY
            };
            piegraph_data.push(tmp_dict)
        }
    }
    return (
        <>
            <g transform={transform_data}>
                <circle r={radius} cx={pt_cx} cy={pt_cy} stroke={colorData.Hinweis}
                        strokeDasharray={`${circumference}, 0`} strokeWidth="100" fill={"transparent"}/>
                <circle r={radius} cx={pt_cx} cy={pt_cy} stroke={colorData.Potenzial}
                        strokeDasharray={`${(arc_length_hin_pot_risk[1] + arc_length_hin_pot_risk[2])}, ${circumference}`}
                        strokeWidth="100" fill={"transparent"}/>
                <circle r={radius} cx={pt_cx} cy={pt_cy} stroke={colorData.Risiko}
                        strokeDasharray={`${arc_length_hin_pot_risk[2]}, ${circumference}`}
                        strokeWidth="100" fill={"transparent"}/>
            </g>
            <g transform={transform_data}
            >
                {
                    piegraph_data.map((k, j) =>
                        <g key={'piegraph_uid' + j.toString()}>
                            <text transform={`translate(${200},${100})`}
                                  x={k.posX}
                                  y={k.posY} style={{font: 'bold italic 10px sans-serif'}}
                                  dominantBaseline="middle" textAnchor="start" fill="black">{k.labeltxt}
                            </text>
                        </g>)
                }

            </g>
            <g transform={transform_data}>

                <rect x={-10 - 23} y={187 + 18} height={30 + 5} width={50 + 20} fill='transparent' stroke="black"/>

                <rect x={-5 - 20} y={193 + 20} height={3} width={20} fill={colorData.Hinweis}
                      stroke={colorData.Hinweis}/>
                <text className='piegraphlegend' x={17 - 5} y={195 + 20} dominantBaseline="start"
                      textAnchor="middle"
                      fill="black">Hinweis
                </text>

                <rect x={-5 - 20} y={201 + 20} height={3} width={20} fill={colorData.Potenzial}
                      stroke={colorData.Potenzial}/>
                <text className='piegraphlegend' x={19 - 5} y={204 + 20} dominantBaseline="start"
                      textAnchor="middle"
                      fill="black">Potenzial
                </text>

                <rect x={-5 - 20} y={209 + 20} height={3} width={20} fill={colorData.Risiko} stroke={colorData.Risiko}/>
                <text className='piegraphlegend' x={15 - 5} y={212 + 20} dominantBaseline="start"
                      textAnchor="middle"
                      fill="black">Risiko
                </text>
            </g>
        </>)

}

export default PieGraphWebReport;
